import { AUTH_ROUTES, LOGGED_IN_PARAM } from 'dotcom-core/src/helpers/authUrl';
import { isTruthy } from './predicate';

function getLoginUrl({
  returnTo,
  showRegister,
}: {
  returnTo?: string;
  showRegister?: boolean;
}) {
  if (!isTruthy(returnTo)) {
    throw new Error('getLoginUrl: returnTo is required');
  }

  try {
    const returnUrl = new URL(returnTo);

    returnUrl.protocol = 'https:';
    returnUrl.searchParams.set(LOGGED_IN_PARAM, 'true');

    const authUrl = new URL(
      showRegister ? AUTH_ROUTES.REGISTER : AUTH_ROUTES.LOGIN,
      returnUrl.origin,
    );

    authUrl.searchParams.set('returnTo', returnUrl.toString());

    return authUrl.toString();
  } catch (error) {
    throw new Error(`Invalid returnTo URL: ${returnTo} Error: ${error}`);
  }
}

export { getLoginUrl };
